import { Component, OnInit } from '@angular/core';
import {NgbModal } from '@ng-bootstrap/ng-bootstrap'; //, ModalDismissReasons
import {Router, ActivatedRoute } from '@angular/router'; //, Params

import { UserProvider } from '../providers/user/user';
import { BasicProvider } from '../providers/basic/basic';

import { ResetpassPopupComponent } from '../resetpass-popup/resetpass-popup.component';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.css']
})
export class ResetPasswordComponent implements OnInit {

  constructor(
    public bp:BasicProvider, 
    public up:UserProvider,
    private activatedRoute: ActivatedRoute,
    public router: Router,
    private modalService: NgbModal,
  ) {
      console.log('dfd');
   }

  ngOnInit() {
    let token = this.activatedRoute.snapshot.params['token'];
    this.verifyAccount(token);
  }

  verifyAccount(token){
    this.bp.hitApi('web/reset-password/'+token, 'GET', {}, true, true)
    .subscribe(
      success => {
        if (success.type == true) {
          this.bp.close();
          this.bp.temp_id = success.data.id;
          this.bp.model_type = 'resetpass';
          this.bp.model = this.modalService.open(ResetpassPopupComponent, { windowClass: 'reset-modal' });
          return false;
        } else {
          this.bp.show_toast('Error',success.message);
          this.router.navigate(['home']);
        }
      }, 
      error => {

      }
    );
  }

}



// WEBPACK FOOTER //
// ./src/app/reset-password/reset-password.component.ts